const Resume = () => {
    return (
      <div id="resume" className="text-center mb-12">
        <a
          href="Tamiyah_Qazi_Resume.pdf" 
          download="Tamiyah_Qazi_Resume.pdf" 
          className="bg-pink-300 text-black font-bold py-2 px-4 rounded-lg hover:bg-cyan-200 transition"
        >
          Download Resume
        </a>
      </div>
    );
  };
  
  export default Resume;
  
